import { Component, OnInit } from '@angular/core';
import { PoheaderService } from 'src/app/services/poheader.service';
import { VMSPAYMENTINFORMATIONModel } from 'src/app/model/vms-payment-information-model';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-paymentinfo',
  templateUrl: './paymentinfo.component.html',
  styleUrls: ['./paymentinfo.component.css']
})
export class PaymentinfoComponent implements OnInit {
LstPaymentInfo :VMSPAYMENTINFORMATIONModel[]=[];
TempLstPaymentInfo :VMSPAYMENTINFORMATIONModel[]=[];
InvoiceNo:any;
  constructor(private PoHeaderSer:PoheaderService, private route: ActivatedRoute,
    private router: Router) {
      this.route.queryParams
      .subscribe(params => { 
        this.InvoiceNo =params['InvoiceNo'] || 0;
      });
    }

  ngOnInit() {  
    this.GetPaymentInformationList();
  }

  GetPaymentInformationList(){        
    this.PoHeaderSer.GetAllPaymentInformation(this.InvoiceNo).subscribe(
      res=> {
        console.log(res.Data)
     this.TempLstPaymentInfo=res.Data;
     this.LstPaymentInfo=this.TempLstPaymentInfo.filter((S:VMSPAYMENTINFORMATIONModel) => S["PAYMENT_POSTED_INVOICE_NO"] == this.InvoiceNo);
      },
      error=>{  
        console.log(error);
        console.error();
      }
    ); 
} 

}
